// api/timesheets.jsx
import {get, getBlob, patch} from "@/lib/fetcher";

export async function getTimesheets(params = {}) {
    return await get("/admin/timesheets", params);
}

export async function getTimesheet(id) {
    return await get(`/admin/timesheets/${id}`);
}

export async function getTimesheetsPdf(jobId){
    return await getBlob (`/admin/timesheets/pdf?job_id=${jobId}`)
}

export async function patchTimesheet(id, data) {
    return await patch(`/admin/timesheets/${id}`, data);
}
